import * as React from 'react';

import usePermissions from 'hooks/usePermissions';
import { useTestNotification, useTriggerSecurityEventNotification } from 'security-app/hooks/useSecurityEventsAPI';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import StepActionButton from './StepActionButton';

type Props = {
  eventId?: string;
  step: EventProcedureStepAPIType;
};

function StepSendNotification({ step, eventId = undefined }: Props) {
  const { notification_id } = step.action.config;

  const { isPermitted } = usePermissions();
  const disabled = !isPermitted(`eventnotifications:edit:${notification_id}`);

  const { triggerSecurityEventNotification, triggeringSecurityEventNotification } =
    useTriggerSecurityEventNotification();
  const { testNotification, testingNotification } = useTestNotification();

  const onClick = React.useCallback(() => {
    if (eventId) {
      triggerSecurityEventNotification({ id: eventId, notificationId: notification_id, stepId: step.id });
    } else {
      testNotification({ id: notification_id });
    }
  }, [eventId, triggerSecurityEventNotification, notification_id, step.id, testNotification]);

  return (
    <StepActionButton
      hint={disabled ? "You don't have access to execute this notification" : undefined}
      title={eventId ? 'Send Notification' : 'Test Notification'}
      onClick={disabled ? null : onClick}
      disabled={disabled || triggeringSecurityEventNotification || testingNotification}
    />
  );
}

export default StepSendNotification;
